// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionPosition: 'right'
	}
};

(function () {
	BoostPFS.inject(this);
	// Customize style of Suggestion box
	SearchInput.prototype.customizeAutoCompleteResizeMenu = function () {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
		if (jQ(searchBoxId).parent().hasClass('header-bar__search-form')) {
      		suggestionElement.outerWidth(300);
		}
	};
})();